module.exports = __webpack_public_path__ + "img/time.5a32998.webp";